// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3NaAj","containerItemsCenter":"Skeleton_containerItemsCenter__2Gne4"};